import { createSlice } from "@reduxjs/toolkit";
import data from '../utils/dummyData/PayrollAdvanceMismatch.json';

const initialState = {
    isConfirmationPopupOpen: false,
    payrollAdvanceRequest: [],
    cashAdvanceDesign: false,
    isOpenCashAdvancePopup: false,
    isOpenDisableCashAdvancePopup: false,
    payrollPageActiveButton: {
        name: "",
        payrollId: null
    },
    isFromPayrollPage: false,
    ShowConfirmationButton: false,
    payrollCount: 0,
    payrollReduxAdvanceList: {},
    isOpenSuccessModal: false,
    ContinueToConfirm: false,
    IsReplaceBaseSalary: false,
    uploadNewBaseSalaryStatistics: {},
    uploadNewBaseSalaryData: [],
    cashAdvanceDetails: data.Payload.payrollAdvanceDetailsList,
    showCashAdvanceDetails: false,
    checkerAdvanceId: 0,
    IsUpdatingCashAdvance: false,
};

const confirmAdvancePopupSlice = createSlice({
    name: "advancePayrollConfirmPopup",
    initialState,
    reducers: {
        setIsConfirmationPopupOpen: (state, action) => {
            state.isConfirmationPopupOpen = action.payload;
        },
        setPayrollAdvanceRequest: (state, action) => {
            state.payrollAdvanceRequest = action.payload;
        },
        setCashAdvanceDesign: (state, action) => {
            state.cashAdvanceDesign = action.payload;
        },
        setIsOpenCashAdvancePopup: (state, action) => {
            state.isOpenCashAdvancePopup = action.payload;
        },
        setIsOpenDisableCashAdvancePopup: (state, action) => {
            state.isOpenDisableCashAdvancePopup = action.payload;
        },
        setPayrollPageActiveButton: (state, action) => {
            state.payrollPageActiveButton = action.payload;
            state.ShowConfirmationButton = false;
        },
        setIsFromPayrollPage: (state, action) => {
            state.isFromPayrollPage = action.payload;
        },
        setShowConfirmationButton: (state, action) => {
            state.ShowConfirmationButton = action.payload;
        },
        setPayrollCount: (state, action) => {
            state.payrollCount = action.payload;
        },
        setReduxPayrollAdvanceList: (state, action) => {
            state.payrollReduxAdvanceList = action.payload;
        },
        setIsOpenSuccessModal: (state, action) => {
            state.isOpenSuccessModal = action.payload;
        },
        setContinueToConfirm: (state, action) => {
            state.ContinueToConfirm = action.payload;
        },
        setUploadNewBaseSalaryStatistics: (state, action) => {
            state.uploadNewBaseSalaryStatistics = action.payload;
        },
        setUploadNewBaseSalaryData: (state, action) => {
            state.uploadNewBaseSalaryData = action.payload;
        },
        setIsReplaceBaseSalary: (state, action) => {
            state.IsReplaceBaseSalary = action.payload;
        },
        setCashAdvanceDetails: (state, action) => {
            state.cashAdvanceDetails = action.payload;
        },
        setShowCashAdvanceDetails: (state, action) => {
            state.showCashAdvanceDetails = action.payload;
        },
        setCheckerAdvanceId: (state, action) => {
            state.checkerAdvanceId = action.payload;
        },
        setIsUpdatingCashAdvance: (state, action) => {
            state.IsUpdatingCashAdvance = action.payload;
        }
    }
});

export const { setIsConfirmationPopupOpen, setIsUpdatingCashAdvance, setCheckerAdvanceId, setCashAdvanceDetails, setShowCashAdvanceDetails, setUploadNewBaseSalaryData, setUploadNewBaseSalaryStatistics, setIsReplaceBaseSalary, setContinueToConfirm, setIsOpenSuccessModal, setReduxPayrollAdvanceList, setPayrollAdvanceRequest, setShowConfirmationButton, setPayrollCount, setIsFromPayrollPage, setPayrollPageActiveButton, setCashAdvanceDesign, setIsOpenCashAdvancePopup, setIsOpenDisableCashAdvancePopup } = confirmAdvancePopupSlice.actions;
export default confirmAdvancePopupSlice.reducer;